import {Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from '../../services/user-verification.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {HttpService} from '../../services/http.service';
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-select-edit',
  templateUrl: './select-edit.component.html',
})
export class SelectEditComponent implements OnInit, OnDestroy {

  public isAdmin: boolean = false;
  public inputIsDisable = true;
  public inputIsHidden = false;
  public selectIsDisable = false;
  public selectIsHidden = true;
  public inputInit;
  public platformId;
  public isAdminSubscription: Subscription;
  public allPlatforms: any[] = [];
  public showPrimarySearch = false;
  public showSecondarySearch = false;
  public searchPrimaryHub = '';
  public haveError = false;
  public errorMessage;
  public hubType;
  platformsList: any[];

  @Input() inputValue;
  @Input() virtId;
  @Input() validationType;
  @ViewChild('searchCheck') searchCheck: ElementRef;

  constructor(private userVerificationService: UserVerificationService,
              private http: HttpClient, private httpService: HttpService) {

    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);

  }

  // Live Search functions
  public selectedPlatform(value: string) {
    this.searchPrimaryHub = value;
    this.platformId = value;
    if(this.validationType === 'platform') {
      if(this.platformId == null) {
        this.haveError = true;
      }
      else {
        this.haveError = false;
      }
    }
  }

  public removed(value: string) {
    this.platformId = '';
    if (this.validationType === 'platform') {
      if (!this.platformId) {
        this.haveError = true;
      }
    }
  }

// Get all Platform Call

  getPlatform() {
    this.showPrimarySearch = true;
    this.httpService.getPlatforms()
      .subscribe(
      platformsListRaw => {
          this.platformsList = platformsListRaw;
          for (const platform of platformsListRaw){
            this.allPlatforms.push({id: platform.platformId, text: platform.platformName});
          }
        }
      );
  }


  inputOnClick() {
    this.inputInit = this.inputValue;
    this.inputIsDisable = false;
    this.haveError = false;
    this.inputIsHidden = true;
    this.selectIsDisable = true;
    this.selectIsHidden = false;
    this.platformId = this.inputValue;
  }

  inputOnSave() {
    let tempValue = this.platformId.toString();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = '';
    var body: any = {};
    if (this.validationType === 'platform') {
      url = ApiEndpoints.UPDATE_PLATFORM;
      body = {
        "virtId": this.virtId,
        "platformId": tempValue
      };
    }
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.inputValue = tempValue
          this.inputIsDisable = true;
          this.inputIsHidden = false;
          this.selectIsDisable = false;
          this.haveError = false;
          this.selectIsHidden = true;
          this.showPrimarySearch = false;
          this.platformId = "";
          this.haveError = false;
          this.errorMessage = "";
        },
        error => {
          try {
            let err = JSON.parse(error._body);
            this.errorMessage = JSON.stringify(err.Description);
          } catch(ex) {
            this.errorMessage = "An error has occured!"
          } finally {
            this.haveError = true;
          }
        }
      );
  }

  inputOnCancel(inputCheck) {
    inputCheck.value = this.getPlatformNameById(this.inputInit);
    this.showPrimarySearch = false;
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
    this.haveError = false;
  }

  ngOnInit() {

    this.getPlatform();

    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });

    if(this.validationType == "platform") {
      this.hubType = 'select2';
    }else {
      this.hubType = 'select3';
    }
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }

  getPlatformNameById(id: number | string): string {
    if (this.platformsList && this.platformsList.length) {
      const platformInfo = this.platformsList.find(pl => pl['platformId'] === id);
      if (platformInfo) {
        return platformInfo['platformName'];
      }
    }
    return null;
  }

}
